import { useEffect, useState } from "react";
import Menu from "./Menu"
import Account from "./Account";
import Cookies from "js-cookie";
import { useUserStore } from "@/stores/useUserStore";
import { initUser } from "@/stores/initialState";
import { useRouter } from "next/router";
import MyVouchers from "./MyVouchers";
import Address from "./Address";
import MyOrders from "./MyOrders";


const User = () => {
  const router = useRouter();
  const viewport = Cookies.get('viewport');
  const { updateUser } = useUserStore();
  const [selected, setSelected] = useState(viewport === "desktop" ? "account_details" : "");

  useEffect(() => {
    if (selected === "logout") {
      setSelected("");
      updateUser(initUser);
      router.push("/");
    }
  }, [selected, updateUser, router])

  return (
    <div className="container grid grid-cols-1 my-12 md:grid-cols-5 gap-x-20">
      {(viewport === "desktop" || selected === "") && (<div className="md:col-span-2">
        <Menu selected={selected} setSelected={setSelected} />
      </div>)}
      <div className="md:col-span-3">
        {selected === "account_details" && <Account selected={selected} setSelected={setSelected} />}
        {selected === "address" && <Address selected={selected} setSelected={setSelected} />}
        {selected === "my_purchase" && <MyOrders selected={selected} setSelected={setSelected} />}
        {selected === "my_voucher" && <MyVouchers selected={selected} setSelected={setSelected} />}
      </div>
    </div>
  )
}

export default User
